import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Breadcrumb,
  ComboBox,
  FontIcon,
  FontSizes,
  FontWeights,

  Label,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  StackItem,
  TextField,
 
} from "@fluentui/react";
import { DateFormatConfigCard } from "./components/DateFormatConfigCard";
import { getDefaultDateFormatForCountry } from "../../Utils/DateFormatUtility";
import { BreadcrumbStyle } from "../Quotation/AddQuotation/AddQuotationStyle";
import { Card, CardStandardHeader } from "@coherence-design-system/controls";
import {
  AUSTRIA,
  BELGIUM,
  CountriesData,
  CountriesOptions,
  allCountries,
  remittanceCurrencyCodeAndCompanyCodeCountries,
} from "./Common/CountriesData";
import {
  
  ICountriesProfileProps,
  IResponseMessage,
  ITermsAndCondition,
  SubmitButtonStyle,
  TextFieldStyles,
  classNames,
  countryComboBoxStyles,
  getBreadcrumbItems,
  stackTokensWithGap10,
  textFieldGray,
} from "./CountriesProfile.type";
import {
 
  intialCountryProfileInfo,
} from "./CountriesProfileContext";
import {
  ABN_IS_REQUIRED,
  ACCOUNT_ADDRESS_REQUIRED,
  ACCOUNT_NAME_REQUIRED,
  ACCOUNT_NUMBER_REQUIRED,
  ADDRESS_REQUIRED,
  BANK_ADDRESS_REQUIRED,
  BANK_KEY_REQUIRED,
  BANK_NAME_REQUIRED,
  BANK_PHONE_REQUIRED,
  BC_CODE_REQUIRED,
  BSB_CODE_REQUIRED,
  CITY_REQUIRED,
  COMPANY_CODE_REQUIRED,
  CORRESPONDING_BANK_REQUIRED,
  CORRESPONDING_BANK_SWIFT_OR_BIC_REQUIRED,
  COUNTRY_CODE_REQUIRED,
  COUNTRY_NAME_REQUIRED,
  CURRENCY_CODE_REQUIRED,
  IBAN_NUMBER_REQUIRED,
  InitialStateOfResponseMessage,
  LANGUAGE_CODE_REQUIRED,
  NAME_IS_REQUIRED,
  POSTALCODE_REQUIRED,
  REGION_REQUIRED,
  SORT_CODE_REQUIRED,
  
  STREET_REQUIRED,
  SWIFT_BIC_CODE_REQUIRED,
  SWIFT_CODE_REQUIRED,
  SWITCH_CODE_REQUIRED,
 
  VAT_ID_REQUIRED,
  validateCountryProfileDetailsFields,
} from "./CountriesProfileValidation";
import { v4 as uuidv4 } from "uuid";
import { CountryProfileService } from "../../services/CountryProfiles/CountryProfileService";
import { useNavigate } from "react-router-dom";
import { appInsights } from "../../services/Logging/AppInsights";
import {
  
  countryWiseStateList,
} from "../CustomerAccount/CustomerFormInitialValues";

const CountryProfileDetails: React.FunctionComponent<ICountriesProfileProps> = (
  props
) => {
  props.onCountryProfile(true);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [countryProfileInfo, setCountryProfileInfo] = useState(
    intialCountryProfileInfo
  );
  const [countryProfileError, setCountryProfileError] = useState(
    intialCountryProfileInfo
  );
  const [termsAndCondiditionSelectedFile, setTermsAndCondiditionSelectedFile] =
    useState<File>();
  const [countryProfileFailureMessage, setCountryProfileFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const termsAndConditionFileInputRef = useRef<HTMLInputElement>(null);
  const [filteredOriginState, setFilteredOriginState] = useState<any[]>([]);
  const [filteredWarehouseState, setFilteredWarehouseState] = useState<any[]>(
    []
  );
  const [termsAndConditions, setTermsAndConditions] =
    useState<ITermsAndCondition[]>();
  const handleTermsAndConditionFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTermsAndCondiditionSelectedFile(event.target.files?.[0]);
  };
  const [existingCountry, setExistingCountry] = useState([]);
  useEffect(() => {
    try {
      CountryProfileService.getCountriesAllCountriesName().then((res) => {
        if (res.data.data) {
          setExistingCountry(res.data.data);
        }
      });
    } catch (err) {
      appInsights.trackException({
        error: new Error(err as string),
        properties: {
          name: "error while fetching the existing countries details CountryProfileDetails.tsx",
        },
      });
    }
  }, []);
  useEffect(() => {
    setCountryProfileInfo({
      ...countryProfileInfo,
      administrativeOriginState: "",
    });
  }, [filteredOriginState]);
  useEffect(() => {
    setCountryProfileInfo({
      ...countryProfileInfo,
      warehouseState: "",
    });
  }, [filteredWarehouseState]);

  const countriesList = CountriesOptions.map((item) => ({
    ...item,
    disabled: existingCountry.includes(item.key.toUpperCase() as never),
  }));
  const _OnClickSubmitButton = async (e: Event) => {
    e.preventDefault();
    setIsLoading(true);
    setCountryProfileError(intialCountryProfileInfo);
    const { isValidated, countryProfileErrors } =
      validateCountryProfileDetailsFields(countryProfileInfo);
    const remittanceCurrency = remittanceCurrencyCodeAndCompanyCodeCountries.includes(countryProfileInfo?.countryName.toLowerCase());
    const remittanceCompany = (remittanceCurrency) || [AUSTRIA.toLowerCase(), BELGIUM.toLowerCase()].includes(countryProfileInfo?.countryName?.toLowerCase());
    if (isValidated) {
      let newCountryProfile = {
        countryName: countryProfileInfo?.countryName,
        twoDigitCountryCode:
          countryProfileInfo?.twoDigitCountryCode?.length > 0
            ? countryProfileInfo.twoDigitCountryCode
            : null,
        currencyCode:
          countryProfileInfo?.currencyCode?.length > 0
            ? countryProfileInfo.currencyCode
            : null,
        countryDigitCode:
          countryProfileInfo?.countryDigitCode?.length > 0
            ? countryProfileInfo.countryDigitCode
            : null,
        languageCode:
          countryProfileInfo.languageCode?.length > 0
            ? countryProfileInfo.languageCode
            : null,
        region:
          countryProfileInfo?.region?.length > 0
            ? countryProfileInfo.region
            : null,
        countryCode:
          countryProfileInfo?.countryCode?.length > 0
            ? countryProfileInfo.countryCode
            : null,
        warehouseCountry:
          countryProfileInfo?.warehouseCountry?.length > 0
            ? countryProfileInfo.warehouseCountry
            : null,
        warehouseCity:
          countryProfileInfo?.warehouseCity?.length > 0
            ? countryProfileInfo.warehouseCity
            : null,
        warehouseStreet:
          countryProfileInfo?.warehouseStreet?.length > 0
            ? countryProfileInfo.warehouseStreet
            : null,
        warehouseZipCode:
          countryProfileInfo?.warehouseZipCode?.length > 0
            ? countryProfileInfo.warehouseZipCode
            : null,
        warehouseState:
          countryProfileInfo?.warehouseState?.length > 0
            ? countryProfileInfo.warehouseState
            : null,
        administrativeOriginName:
          countryProfileInfo?.administrativeOriginName?.length > 0
            ? countryProfileInfo.administrativeOriginName
            : null,
        administrativeOriginState:
          countryProfileInfo?.administrativeOriginState?.length > 0
            ? countryProfileInfo.administrativeOriginState
            : null,
        administrativeOriginCountry:
          countryProfileInfo?.administrativeOriginCountry?.length > 0
            ? countryProfileInfo.administrativeOriginCountry
            : null,
        administrativeOriginCity:
          countryProfileInfo?.administrativeOriginCity?.length > 0
            ? countryProfileInfo.administrativeOriginCity
            : null,
        administrativeOriginStreet:
          countryProfileInfo?.administrativeOriginStreet?.length > 0
            ? countryProfileInfo.administrativeOriginStreet
            : null,
        administrativeOriginZipCode:
          countryProfileInfo?.administrativeOriginZipCode?.length > 0
            ? countryProfileInfo.administrativeOriginZipCode
            : null,
        eTag:
          countryProfileInfo?.eTag?.length > 0 ? countryProfileInfo.eTag : null,
        id: countryProfileInfo.id?.length > 0 ? countryProfileInfo.id : null,
        partitionKey:
          countryProfileInfo?.partitionKey?.length > 0
            ? countryProfileInfo.partitionKey
            : null,
        companyCode:
          countryProfileInfo?.companyCode?.length > 0
            ? countryProfileInfo.companyCode
            : null,
        isActive:
          countryProfileInfo?.isActive?.length > 0
            ? countryProfileInfo.isActive
            : null,
        createdBy:
          countryProfileInfo?.createdBy?.length > 0
            ? countryProfileInfo.createdBy
            : null,
        updatedBy:
          countryProfileInfo?.updatedBy?.length > 0
            ? countryProfileInfo.updatedBy
            : null,
        createdAt:
          countryProfileInfo?.createdAt?.length > 0
            ? countryProfileInfo.createdAt
            : null,
        updatedAt:
          countryProfileInfo?.updatedAt?.length > 0
            ? countryProfileInfo.updatedAt
            : null,
        vatId:
          countryProfileInfo?.vatId?.length > 0
            ? countryProfileInfo.vatId
            : null,
        termsAndConditions: [] as ITermsAndCondition[],
        bankName:
          countryProfileInfo?.bankName?.length > 0
            ? countryProfileInfo.bankName
            : null,
        bankAddress:
          countryProfileInfo?.bankAddress?.length > 0
            ? countryProfileInfo.bankAddress
            : null,
        addressLine1: countryProfileInfo?.addressLine1?.length > 0 ? countryProfileInfo?.addressLine1 : null,
        addressLine2: countryProfileInfo?.addressLine2?.length > 0 ? countryProfileInfo?.addressLine2 : null,
        addressLine3: countryProfileInfo?.addressLine3?.length > 0 ? countryProfileInfo?.addressLine3 : null,
        accountName:
          countryProfileInfo?.accountName?.length > 0
            ? countryProfileInfo.accountName
            : null,
        accountNumber:
          countryProfileInfo?.accountNumber?.length > 0
            ? countryProfileInfo.accountNumber
            : null,
        accountAddress:
          countryProfileInfo?.accountAddress?.length > 0
            ? countryProfileInfo.accountAddress
            : null,
        iban:
          countryProfileInfo?.iban?.length > 0 ? countryProfileInfo.iban : null,
        swiftCode:
          countryProfileInfo?.swiftCode?.length > 0
            ? countryProfileInfo.swiftCode
            : null,
        swiftBICCode:
          countryProfileInfo?.swiftBicCode?.length > 0
            ? countryProfileInfo.swiftBicCode
            : null,
        switchCode:
          countryProfileInfo?.switchCode?.length > 0
            ? countryProfileInfo.switchCode
            : null,
        correspondingBank:
          countryProfileInfo?.correspondingBank?.length > 0
            ? countryProfileInfo.correspondingBank
            : null,
        correspondingBankSwiftBICCode:
          countryProfileInfo?.correspondingBankSwiftBICCode?.length > 0
            ? countryProfileInfo.correspondingBankSwiftBICCode
            : null,
        bankCompanyCode:
          countryProfileInfo?.bankCompanyCode?.length > 0
            ? countryProfileInfo.bankCompanyCode
            : null,
        sortCode:
          countryProfileInfo?.sortCode?.length > 0
            ? countryProfileInfo.sortCode
            : null,
        currency:
          countryProfileInfo?.currencyCode?.length > 0
            ? countryProfileInfo.currencyCode
            : null,
        bcCode:
          countryProfileInfo?.bcCode?.length > 0
            ? countryProfileInfo.bcCode
            : null,
        abn:
          countryProfileInfo?.abn?.length > 0 ? countryProfileInfo.abn : null,
        bsbCode:
          countryProfileInfo?.bsbCode?.length > 0
            ? countryProfileInfo.bsbCode
            : null,
        bankKey:
          countryProfileInfo?.bankKey?.length > 0
            ? countryProfileInfo.bankKey
            : null,
        bankPhone:
          countryProfileInfo?.bankPhone?.length > 0
            ? countryProfileInfo.bankPhone
            : null,
        remittanceCurrencyCode: (remittanceCurrency) ? countryProfileInfo?.currencyCode : "",
        remittanceCompanyCode: (remittanceCompany) ? countryProfileInfo?.companyCode : "",
        // Include the date format from localStorage (check both keys) or use the default for this country
  dateFormat: getDefaultDateFormatForCountry(countryProfileInfo?.countryName),
      };
      if (!termsAndCondiditionSelectedFile) {
        setCountryProfileFailureMessage({
          showMessage: true,
          message: "Terms and Conditions Document is required",
        });
        setIsLoading(false);
      } else {
        const promises = [];
        const termsAndConditionFormData = new FormData();
        termsAndConditionFormData.append(
          "file",
          termsAndCondiditionSelectedFile
        );
        const termsAndConditionsDocumentId = uuidv4();
        const termsAndConditionUploadPromise =
          CountryProfileService.uploadDocument(
            termsAndConditionsDocumentId,
            termsAndConditionFormData
          )
            .then((res) => {
              if (res !== undefined) {
                const tAndCFile = {
                  id: termsAndConditionsDocumentId,
                  name: termsAndCondiditionSelectedFile.name,
                  createdAt: `${new Date().toLocaleDateString() +
                    " " +
                    new Date().toLocaleTimeString()
                    }`,
                };
                newCountryProfile.termsAndConditions.push(tAndCFile);
              }
            })
            .catch((error) => {
              setIsLoading(false);
              appInsights.trackException({
                error: new Error(error as string),
                properties: {
                  name: "Error in uploadDocument API in create CountryProfileDetails.tsx",
                },
              });
            });
        promises.push(termsAndConditionUploadPromise);
        await Promise.all(promises);
        await CountryProfileService.addNewCountryProfile(newCountryProfile)
          .then((res: any) => {
            if (res !== undefined) {
              setIsLoading(false);
              const response = res.data.data.data;
              navigate("/CountryProfile");
            }
          })
          .catch((error) => {
            setIsLoading(false);
            appInsights.trackException({
              error: new Error(error as string),
              properties: {
                name: "Error in AddCountryProfile API in CountryProfileOtherDetails.tsx",
              },
            });
          });
      }
    } else {
      setIsLoading(false);
      setCountryProfileError(countryProfileErrors);
    }
  };
  const handleTermsAndConditionClick = () => {
    if (termsAndConditionFileInputRef.current) {
      termsAndConditionFileInputRef.current.click();
    }
  };
  const handleTermsAndConditionDragAndDrop = (file: File) => {
    setTermsAndCondiditionSelectedFile(file);
  };
  const setBasicDetails = (countryName: any) => {
    let countryInfo = CountriesData.filter(
      (x) => x.countryName === countryName?.text
    )[0];
    setCountryProfileInfo({
      ...countryProfileInfo,
      countryCode: countryInfo.countryCode,
      currencyCode: countryInfo.currencyCode,
      countryName: countryInfo.countryName,
      languageCode: countryInfo.languageCode,
      companyCode: countryInfo.companyCode,
      region: countryInfo.region,
      twoDigitCountryCode: countryInfo.twoDigitCountryCode,
    });
    setCountryProfileError({
      ...countryProfileError,
      countryName: "",
      currencyCode: "",
      countryCode: "",
      languageCode: "",
      companyCode: "",
      region: "",
    });
  };
  const countryRemittanceDetails = (countryName: string) => {
    switch (countryName.toLowerCase()) {
      case "ireland":
        return irelandRemittanceDetails();
      case "luxembourg":
        return luxembourgRemittanceDetails();
      case "portugal":
        return portugalRemittanceDetails();
      case "germany":
        return germanyRemittanceDetails();
      case "france":
        return franceRemittanceDetails();
      case "sweden":
        return swedanRemittanceDetails();
      case "norway":
        return norwayRemittanceDetails();
      case "denmark":
        return denmarkRemittanceDetails();
      case "switzerland":
        return switzerlandRemittanceDetails();
      case "belgium":
        return belgiumRemittanceDetails();
      case "austria":
        return austriaRemittanceDetails();
      case "finland":
        return finlandRemittanceDetails();
      case "netherlands":
        return netherlandsRemittanceDetails();
      case "italy":
        return italyRemittanceDetails();
      case "spain":
        return spainRemittanceDetails();
      case "japan":
        return japanRemittanceDetails();
      case "new zealand":
        return newzealandRemittanceDetails();
      case "singapore":
        return singaporeRemittanceDetails();
      case "australia":
        return australiaRemittanceDetails();
    }
  };
  const australiaRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Australian Business Number (ABN)*​"
                  name="abn"
                  value={countryProfileInfo.abn}
                  onChange={(e, abnvalue) => {
                    if (abnvalue && abnvalue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        abn: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        abn: ABN_IS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      abn: abnvalue || "",
                    });
                  }}
                  errorMessage={countryProfileError.abn}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="BSB Code*​"
                  name="bsbCode"
                  value={countryProfileInfo.bsbCode}
                  onChange={(e, bsbCodeValue) => {
                    if (bsbCodeValue && bsbCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bsbCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bsbCode: BSB_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bsbCode: bsbCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bsbCode}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const irelandRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="IBAN Number*"
                  name="ibanNumber"
                  value={countryProfileInfo.iban}
                  onChange={(e, ibanValue) => {
                    if (ibanValue && ibanValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: IBAN_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      iban: ibanValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.iban}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="VAT*"
                  name="vatId"
                  value={countryProfileInfo.vatId}
                  onChange={(e, vatIdValue) => {
                    if (vatIdValue && vatIdValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: VAT_ID_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      vatId: vatIdValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.vatId}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Sort Code*"
                  name="sortCode"
                  value={countryProfileInfo.sortCode}
                  onChange={(e, sortCodeValue) => {
                    if (sortCodeValue && sortCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        sortCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: SORT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      sortCode: sortCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.sortCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Corresponding Bank*"
                  name="correspondingBank"
                  value={countryProfileInfo.correspondingBank}
                  onChange={(e, correspondingBankValue) => {
                    if (
                      correspondingBankValue &&
                      correspondingBankValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBank: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBank: CORRESPONDING_BANK_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      correspondingBank: correspondingBankValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.correspondingBank}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Corresponding Bank Swift / BIC Code*"
                  name="correspondingBankSwiftBICCode"
                  value={countryProfileInfo.correspondingBankSwiftBICCode}
                  onChange={(e, correspondingBankSwiftBICCodeValue) => {
                    if (
                      correspondingBankSwiftBICCodeValue &&
                      correspondingBankSwiftBICCodeValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBankSwiftBICCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBankSwiftBICCode:
                          CORRESPONDING_BANK_SWIFT_OR_BIC_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      correspondingBankSwiftBICCode:
                        correspondingBankSwiftBICCodeValue || "",
                    });
                  }}
                  errorMessage={
                    countryProfileError.correspondingBankSwiftBICCode
                  }
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const luxembourgRemittanceDetails = irelandRemittanceDetails;
  const portugalRemittanceDetails = irelandRemittanceDetails;
  const germanyRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNameValue) => {
                    if (bankNameValue && bankNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Phone*"
                  name="bankPhone"
                  value={countryProfileInfo.bankPhone}
                  onChange={(e, bankPohneValue) => {
                    if (bankPohneValue && bankPohneValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankPhone: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_PHONE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankPhone: bankPohneValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankPhone}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Address*"
                  name="accountAddress"
                  value={countryProfileInfo.accountAddress}
                  onChange={(e, accountAddressValue) => {
                    if (
                      accountAddressValue &&
                      accountAddressValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountAddress: ACCOUNT_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountAddress: accountAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountAddress}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="IBAN Number*"
                  name="ibanNumber"
                  value={countryProfileInfo.iban}
                  onChange={(e, ibanValue) => {
                    if (ibanValue && ibanValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: IBAN_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      iban: ibanValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.iban}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="VAT*"
                  name="vatId"
                  value={countryProfileInfo.vatId}
                  onChange={(e, vatIdValue) => {
                    if (vatIdValue && vatIdValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: VAT_ID_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      vatId: vatIdValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.vatId}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Corresponding Bank Swift / BIC Code*"
                  name="correspondingBankSwiftBICCode"
                  value={countryProfileInfo.correspondingBankSwiftBICCode}
                  onChange={(e, correspondingBankSwiftBICCodeValue) => {
                    if (
                      correspondingBankSwiftBICCodeValue &&
                      correspondingBankSwiftBICCodeValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBankSwiftBICCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBankSwiftBICCode:
                          CORRESPONDING_BANK_SWIFT_OR_BIC_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      correspondingBankSwiftBICCode:
                        correspondingBankSwiftBICCodeValue || "",
                    });
                  }}
                  errorMessage={
                    countryProfileError.correspondingBankSwiftBICCode
                  }
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const franceRemittanceDetails = germanyRemittanceDetails;
  const swedanRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNameValue) => {
                    if (bankNameValue && bankNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="IBAN Number*"
                  name="ibanNumber"
                  value={countryProfileInfo.iban}
                  onChange={(e, ibanValue) => {
                    if (ibanValue && ibanValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: IBAN_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      iban: ibanValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.iban}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="VAT*"
                  name="vatId"
                  value={countryProfileInfo.vatId}
                  onChange={(e, vatIdValue) => {
                    if (vatIdValue && vatIdValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: VAT_ID_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      vatId: vatIdValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.vatId}
                />
                <TextField
                  styles={textFieldGray}
                  label="Currency Code*"
                  name="currencyCode"
                  value={countryProfileInfo.currencyCode}
                  onChange={(e, currencyCodeValue) => {
                    if (currencyCodeValue && currencyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: CURRENCY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      currencyCode: currencyCodeValue || "",
                    });
                  }}
                  readOnly
                  tabIndex={-1}
                  errorMessage={countryProfileError.currencyCode}
                />
                <TextField
                  styles={textFieldGray}
                  label="Company Code*"
                  name="companyCode"
                  value={countryProfileInfo.companyCode}
                  onChange={(e, companyCodeValue) => {
                    if (companyCodeValue && companyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: COMPANY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      companyCode: companyCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.companyCode}
                  readOnly
                  tabIndex={-1}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const norwayRemittanceDetails = swedanRemittanceDetails;
  const denmarkRemittanceDetails = swedanRemittanceDetails;
  const switzerlandRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="IBAN Number*"
                  name="ibanNumber"
                  value={countryProfileInfo.iban}
                  onChange={(e, ibanValue) => {
                    if (ibanValue && ibanValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: IBAN_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      iban: ibanValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.iban}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="VAT*"
                  name="vatId"
                  value={countryProfileInfo.vatId}
                  onChange={(e, vatIdValue) => {
                    if (vatIdValue && vatIdValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: VAT_ID_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      vatId: vatIdValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.vatId}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="BC Code*"
                  name="bcCode"
                  value={countryProfileInfo.bcCode}
                  onChange={(e, bcCodeValue) => {
                    if (bcCodeValue && bcCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bcCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bcCode: BC_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bcCode: bcCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bcCode}
                />
                <TextField
                  styles={textFieldGray}
                  label="Currency Code*"
                  name="currencyCode"
                  value={countryProfileInfo.currencyCode}
                  onChange={(e, currencyCodeValue) => {
                    if (currencyCodeValue && currencyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: CURRENCY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      currencyCode: currencyCodeValue || "",
                    });
                  }}
                  readOnly
                  errorMessage={countryProfileError.currencyCode}
                  tabIndex={-1}
                />
                <TextField
                  styles={textFieldGray}
                  label="Company Code*"
                  name="companyCode"
                  value={countryProfileInfo.companyCode}
                  onChange={(e, companyCodeValue) => {
                    if (companyCodeValue && companyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: COMPANY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      companyCode: companyCodeValue || "",
                    });
                  }}
                  readOnly
                  errorMessage={countryProfileError.companyCode}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const belgiumRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="IBAN Number*"
                  name="ibanNumber"
                  value={countryProfileInfo.iban}
                  onChange={(e, ibanValue) => {
                    if (ibanValue && ibanValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: IBAN_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      iban: ibanValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.iban}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="VAT*"
                  name="vatId"
                  value={countryProfileInfo.vatId}
                  onChange={(e, vatIdValue) => {
                    if (vatIdValue && vatIdValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: VAT_ID_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      vatId: vatIdValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.vatId}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Corresponding Bank*"
                  name="correspondingBank"
                  value={countryProfileInfo.correspondingBank}
                  onChange={(e, correspondingBankValue) => {
                    if (
                      correspondingBankValue &&
                      correspondingBankValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBank: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBank: CORRESPONDING_BANK_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      correspondingBank: correspondingBankValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.correspondingBank}
                />
                <TextField
                  styles={textFieldGray}
                  label="Company Code*"
                  name="companyCode"
                  value={countryProfileInfo.companyCode}
                  onChange={(e, companyCodeValue) => {
                    if (companyCodeValue && companyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: COMPANY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      companyCode: companyCodeValue || "",
                    });
                  }}
                  readOnly
                  errorMessage={countryProfileError.companyCode}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const austriaRemittanceDetails = belgiumRemittanceDetails;
  const finlandRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="IBAN Number*"
                  name="ibanNumber"
                  value={countryProfileInfo.iban}
                  onChange={(e, ibanValue) => {
                    if (ibanValue && ibanValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        iban: IBAN_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      iban: ibanValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.iban}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="VAT*"
                  name="vatId"
                  value={countryProfileInfo.vatId}
                  onChange={(e, vatIdValue) => {
                    if (vatIdValue && vatIdValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        vatId: VAT_ID_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      vatId: vatIdValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.vatId}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Corresponding Bank*"
                  name="correspondingBank"
                  value={countryProfileInfo.correspondingBank}
                  onChange={(e, correspondingBankValue) => {
                    if (
                      correspondingBankValue &&
                      correspondingBankValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBank: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        correspondingBank: CORRESPONDING_BANK_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      correspondingBank: correspondingBankValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.correspondingBank}
                />
                <TextField
                  styles={textFieldGray}
                  label="Currency Code*"
                  name="currencyCode"
                  value={countryProfileInfo.currencyCode}
                  onChange={(e, currencyCodeValue) => {
                    if (currencyCodeValue && currencyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: CURRENCY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      currencyCode: currencyCodeValue || "",
                    });
                  }}
                  readOnly
                  tabIndex={-1}
                  errorMessage={countryProfileError.currencyCode}
                />
                <TextField
                  styles={textFieldGray}
                  label="Company Code*"
                  name="companyCode"
                  value={countryProfileInfo.companyCode}
                  onChange={(e, companyCodeValue) => {
                    if (companyCodeValue && companyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: COMPANY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      companyCode: companyCodeValue || "",
                    });
                  }}
                  readOnly
                  errorMessage={countryProfileError.companyCode}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const netherlandsRemittanceDetails = finlandRemittanceDetails;
  const italyRemittanceDetails = finlandRemittanceDetails;
  const spainRemittanceDetails = finlandRemittanceDetails;
  const japanRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Address Line 1*"
                  name="addressLine1"
                  value={countryProfileInfo.addressLine1}
                  onChange={(e, addressLine1) => {
                    if (addressLine1 && addressLine1?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        addressLine1: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        addressLine1: ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      addressLine1: addressLine1 || "",
                    });
                  }}
                  errorMessage={countryProfileError.addressLine1}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Address Line 2*"
                  name="bankAddress2"
                  value={countryProfileInfo.addressLine2}
                  onChange={(e, addressLine2) => {
                    if (
                      addressLine2 &&
                      addressLine2?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        addressLine2: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        addressLine2: ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      addressLine2: addressLine2 || "",
                    });
                  }}
                  errorMessage={countryProfileError.addressLine2}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Address Line 3*"
                  name="bankAddressLine2"
                  value={countryProfileInfo.addressLine3}
                  onChange={(e, addressLine3) => {
                    if (
                      addressLine3 &&
                      addressLine3?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        addressLine3: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        addressLine3: ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      addressLine3: addressLine3 || "",
                    });
                  }}
                  errorMessage={countryProfileError.addressLine3}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Account*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Swift/BIC Code*"
                  name="swiftBICCode"
                  value={countryProfileInfo.swiftBicCode}
                  onChange={(e, swiftBicCode) => {
                    if (swiftBicCode && swiftBicCode?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftBicCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftBicCode: SWIFT_BIC_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftBicCode: swiftBicCode || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftBicCode}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const newzealandRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Swift Code*"
                  name="swiftCode"
                  value={countryProfileInfo.swiftCode}
                  onChange={(e, swiftCodeValue) => {
                    if (swiftCodeValue && swiftCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        swiftCode: SWIFT_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      swiftCode: swiftCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.swiftCode}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  const singaporeRemittanceDetails = () => {
    return (
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Remittance Address Details" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Name*"
                  name="bankName"
                  value={countryProfileInfo.bankName}
                  onChange={(e, bankNamValue) => {
                    if (bankNamValue && bankNamValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankName: BANK_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankName: bankNamValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Address*"
                  name="bankAddress"
                  value={countryProfileInfo.bankAddress}
                  onChange={(e, bankAddressValue) => {
                    if (bankAddressValue && bankAddressValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankAddress: BANK_ADDRESS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankAddress: bankAddressValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.bankAddress}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Account Name*"
                  name="accountName"
                  value={countryProfileInfo.accountName}
                  onChange={(e, accountNameValue) => {
                    if (accountNameValue && accountNameValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountName: ACCOUNT_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountName: accountNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountName}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Account Number*"
                  name="accountNumber"
                  value={countryProfileInfo.accountNumber}
                  onChange={(e, accountNumberValue) => {
                    if (accountNumberValue && accountNumberValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        accountNumber: ACCOUNT_NUMBER_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      accountNumber: accountNumberValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.accountNumber}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Switch Code*"
                  name="swiitchCode"
                  value={countryProfileInfo.switchCode}
                  onChange={(e, switchCode) => {
                    if (switchCode && switchCode?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        switchCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        switchCode: SWITCH_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      switchCode: switchCode || "",
                    });
                  }}
                  errorMessage={countryProfileError.switchCode}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Bank Key*"
                  name="bankKey"
                  value={countryProfileInfo.bankKey}
                  onChange={(e, bankKeyValue) => {
                    if (bankKeyValue && bankKeyValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankKey: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        bankKey: BANK_KEY_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      bankKey: bankKeyValue || "",
                    });
                  }}
                  errorMessage={
                    countryProfileError.correspondingBankSwiftBICCode
                  }
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    );
  };
  if (isLoading) {
    return <Spinner size={SpinnerSize.large} />;
  }
  return (
    <Stack
      verticalFill
      verticalAlign="start"
      tokens={stackTokensWithGap10}
      style={{ backgroundColor: "#FAF9F8" }}
    >
      {countryProfileFailureMessage.showMessage && (
        <MessageBar
          messageBarType={MessageBarType.error}
          onDismiss={() =>
            setCountryProfileFailureMessage(InitialStateOfResponseMessage)
          }
        >
          {countryProfileFailureMessage.message}
        </MessageBar>
      )}
      <Breadcrumb
        items={getBreadcrumbItems()}
        style={{ marginLeft: "1%", marginBottom: "-5px" }}
        styles={BreadcrumbStyle}
      />
      <Stack horizontal tokens={{ childrenGap: 50 }}>
        <Card>
          <Label
            style={{
              fontSize: FontSizes.size20,
              display: "inline",
              fontWeight: FontWeights.bold,
            }}
          >
            {`New Country Details`}
          </Label>
        </Card>
      </Stack>
      <Stack horizontal style={{ paddingLeft: 20, width: 656, paddingTop: 10 }}>
        <Card header={<CardStandardHeader cardTitle="Country Information" />}>
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <ComboBox
                  data-testid="countryProfile-select"
                  styles={countryComboBoxStyles}
                  label="Country*"
                  autoComplete="on"
                  options={countriesList}
                  selectedKey={countryProfileInfo.countryName}
                  onChange={(e, countryNameValue) => {
                    if (countryNameValue && countryNameValue?.text.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        countryName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        countryName: COUNTRY_NAME_REQUIRED,
                      });
                    }
                    if (countryNameValue && countryNameValue?.text.length > 0) {
                      setBasicDetails(countryNameValue);
                      // Reset user-selected flag when country changes to allow automatic format selection
                      localStorage.removeItem('dateFormatUserSelected');
                      
                      // Directly set preferred date format for the selected country
                      const countryName = countryNameValue.text;
                      const preferredFormat = getDefaultDateFormatForCountry(countryName);
                      if (preferredFormat) {
                        localStorage.setItem('dateFormat', preferredFormat);
                      }
                    }
                  }}
                  allowFreeInput
                  errorMessage={countryProfileError.countryName}
                />
                <TextField
                  styles={textFieldGray}
                  label="Country Code*"
                  name="countryCode"
                  value={countryProfileInfo.countryCode}
                  onChange={(e, countryCodeValue) => {
                    if (countryCodeValue && countryCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        countryCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        countryCode: COUNTRY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      countryCode: countryCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.countryCode}
                  readOnly
                  tabIndex={-1}
                />
                <TextField
                  styles={textFieldGray}
                  label="Language Code*"
                  name="languageCode"
                  value={countryProfileInfo.languageCode}
                  onChange={(e, languageCodeValue) => {
                    if (languageCodeValue && languageCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        languageCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        languageCode: LANGUAGE_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      languageCode: languageCodeValue || "",
                    });
                  }}
                  readOnly
                  tabIndex={-1}
                  errorMessage={countryProfileError.languageCode}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={textFieldGray}
                  label="Region*"
                  name="region"
                  value={countryProfileInfo.region}
                  onChange={(e, regionValue) => {
                    if (regionValue && regionValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        region: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        region: REGION_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      region: regionValue || "",
                    });
                  }}
                  readOnly
                  tabIndex={-1}
                  errorMessage={countryProfileError.region}
                />
                <TextField
                  styles={textFieldGray}
                  label="Currency Code*"
                  name="currencyCode"
                  value={countryProfileInfo.currencyCode}
                  onChange={(e, currencyCodeValue) => {
                    if (currencyCodeValue && currencyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        currencyCode: CURRENCY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      currencyCode: currencyCodeValue || "",
                    });
                  }}
                  readOnly
                  tabIndex={-1}
                  errorMessage={countryProfileError.currencyCode}
                />
                <TextField
                  styles={textFieldGray}
                  label="Company Code*"
                  name="companyCode"
                  value={countryProfileInfo.companyCode}
                  onChange={(e, companyCodeValue) => {
                    if (companyCodeValue && companyCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        companyCode: COMPANY_CODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      companyCode: companyCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.companyCode}
                  readOnly
                  tabIndex={-1}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
      
      {/* Date Format Configuration - Always in edit mode for new countries */}
      <Stack horizontal style={{ paddingLeft: 20, width: 656, paddingTop: 10 }}>
        <DateFormatConfigCard 
          countryName={countryProfileInfo.countryName} 
          isEditMode={true}
          onDateFormatChange={(format) => {
            // Store the selected format to use when saving
            localStorage.setItem('selectedDateFormat', format);
          }}
        />
      </Stack>
      
      <Stack horizontal style={{ paddingLeft: 20, width: 656, paddingTop: 10 }}>
        <Card
          header={<CardStandardHeader cardTitle="Microsoft Office Address" />}
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <TextField
                  styles={TextFieldStyles}
                  label="Name*"
                  name="name"
                  value={countryProfileInfo.administrativeOriginName}
                  onChange={(e, administrativeOriginNameValue) => {
                    if (
                      administrativeOriginNameValue &&
                      administrativeOriginNameValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginName: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginName: NAME_IS_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      administrativeOriginName:
                        administrativeOriginNameValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.administrativeOriginName}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="City*"
                  name="city"
                  value={countryProfileInfo.administrativeOriginCity}
                  onChange={(e, administrativeOrigincityValue) => {
                    if (
                      administrativeOrigincityValue &&
                      administrativeOrigincityValue?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginCity: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginCity: CITY_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      administrativeOriginCity:
                        administrativeOrigincityValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.administrativeOriginCity}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Zip/Postal Code*"
                  name="postalCode"
                  value={countryProfileInfo.administrativeOriginZipCode}
                  onChange={(e, postalCodeValue) => {
                    if (postalCodeValue && postalCodeValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginZipCode: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginZipCode: POSTALCODE_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      administrativeOriginZipCode: postalCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.administrativeOriginZipCode}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <ComboBox
                  data-testid="countryProfile-select"
                  styles={countryComboBoxStyles}
                  label="Country*"
                  autoComplete="on"
                  options={allCountries}
                  selectedKey={countryProfileInfo.administrativeOriginCountry}
                  onChange={(e, countryNameValue) => {
                    if (countryNameValue && countryNameValue?.text.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginCountry: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginCountry: COUNTRY_NAME_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      administrativeOriginCountry:
                        countryNameValue?.text?.toString() || "",
                    });
                    const statesData = countryWiseStateList.filter((item) => {
                      return (
                        item.country.toUpperCase() ===
                        countryNameValue?.text?.toUpperCase()
                      );
                    });
                    setFilteredOriginState(statesData);
                  }}
                  allowFreeInput
                  errorMessage={countryProfileError.administrativeOriginCountry}
                />
                <ComboBox
                  data-testid="countryProfile-select"
                  styles={countryComboBoxStyles}
                  label="State/Province"
                  allowFreeInput
                  autoComplete="on"
                  allowFreeform={true}
                  options={filteredOriginState}
                  selectedKey={countryProfileInfo.administrativeOriginState}
                  onChange={(e, stateValue) => {      
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      administrativeOriginState:
                        stateValue?.key.toString() || "",
                    });
                  }}
                  errorMessage={countryProfileError.administrativeOriginState}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Street (Must not be P.O. Box)*"
                  name="street"
                  value={countryProfileInfo.administrativeOriginStreet}
                  onChange={(e, streetValue) => {
                    if (streetValue && streetValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginStreet: "",
                      });
                    } else {
                      setCountryProfileError({
                        ...countryProfileError,
                        administrativeOriginStreet: STREET_REQUIRED,
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      administrativeOriginStreet: streetValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.administrativeOriginStreet}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={
            <CardStandardHeader cardTitle="Fulfillment Warehouse Address" />
          }
        >
          <Stack horizontal horizontalAlign="space-between">
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <ComboBox
                  data-testid="countryProfile-select"
                  styles={countryComboBoxStyles}
                  label="Country"
                  autoComplete="on"
                  allowFreeform={true}
                  options={allCountries}
                  selectedKey={countryProfileInfo.warehouseCountry}
                  onChange={(e, countryNameValue) => {
                    if (countryNameValue === undefined) {
                      setCountryProfileInfo({
                        ...countryProfileInfo,
                        warehouseCountry: "",
                        warehouseState: "",
                      })
                    }
                    else {
                      setCountryProfileInfo({
                        ...countryProfileInfo,
                        warehouseCountry: countryNameValue?.text.toString() || "",
                      });
                    }
                    if (countryNameValue && countryNameValue?.text.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        warehouseCountry: "",
                      });
                    }
                    const statesData = countryWiseStateList.filter((item) => {
                      return (
                        item.country.toUpperCase() ===
                        countryNameValue?.text?.toUpperCase()
                      );
                    });
                    setFilteredWarehouseState(statesData);
                  }}
                  allowFreeInput
                  errorMessage={countryProfileError.warehouseCountry}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="City"
                  name="city"
                  value={countryProfileInfo.warehouseCity}
                  onChange={(e, cityValue) => {
                    if (cityValue && cityValue?.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        warehouseCity: "",
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      warehouseCity: cityValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.warehouseCity}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Zip/Postal Code"
                  name="postalCode"
                  value={countryProfileInfo.warehouseZipCode}
                  onChange={(e, postalCodeValue) => {
                    if (postalCodeValue && postalCodeValue.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        warehouseZipCode: "",
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      warehouseZipCode: postalCodeValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.warehouseZipCode}
                />
              </StackItem>
            </Stack>
            <Stack verticalFill verticalAlign="start">
              <StackItem verticalFill>
                <ComboBox
                  data-testid="countryProfile-select"
                  styles={countryComboBoxStyles}
                  label="State/Province"
                  autoComplete="on"
                  allowFreeform={true}
                  allowFreeInput
                  options={filteredWarehouseState}
                  selectedKey={countryProfileInfo.warehouseState}
                  onChange={(e, stateValue) => {
                    if (stateValue === undefined) {
                      setCountryProfileInfo({
                        ...countryProfileInfo,
                        warehouseState: "",
                      });
                    }
                    else {
                      setCountryProfileInfo({
                        ...countryProfileInfo,
                        warehouseState: stateValue?.key.toString() || "",
                      });
                    }
                    if (
                      stateValue?.key &&
                      stateValue?.key.toString()?.length > 0
                    ) {
                      setCountryProfileError({
                        ...countryProfileError,
                        warehouseState: "",
                      });
                    }
                  }}
                  errorMessage={countryProfileError.warehouseState}
                />
                <TextField
                  styles={TextFieldStyles}
                  label="Street (Must not be P.O. Box)"
                  name="street"
                  value={countryProfileInfo.warehouseStreet}
                  onChange={(e, streetValue) => {
                    if (streetValue && streetValue.length > 0) {
                      setCountryProfileError({
                        ...countryProfileError,
                        warehouseStreet: "",
                      });
                    }
                    setCountryProfileInfo({
                      ...countryProfileInfo,
                      warehouseStreet: streetValue || "",
                    });
                  }}
                  errorMessage={countryProfileError.warehouseStreet}
                />
              </StackItem>
            </Stack>
          </Stack>
        </Card>
      </Stack>
      {/* Remittance Details */}
      {countryProfileInfo.countryName &&
        countryRemittanceDetails(countryProfileInfo.countryName)}
      <Stack horizontal style={{ paddingLeft: 20, width: 658, paddingTop: 10 }}>
        <Card
          header={
            <CardStandardHeader cardTitle="Terms and Conditions (Landscape only PDF)*" />
          }
          styles={{ root: { background: "#f2f2f2" } }}
        >
          <Stack
            horizontal
            horizontalAlign="space-between"
            styles={{
              root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
            }}
            onDragOver={(e: React.DragEvent<HTMLDivElement>) => {
              e.preventDefault();
            }}
            onDrop={(e: React.DragEvent<HTMLDivElement>) => {
              e.preventDefault();
              if (e.dataTransfer.items) {
                const file = e.dataTransfer?.files[0];
                handleTermsAndConditionDragAndDrop(file);
              }
            }}
          >
            <Stack
              horizontal
              style={{
                alignItems: "center",
              }}
            >
              <FontIcon
                iconName="CloudWeather"
                className={classNames.deepSkyBlue}
              />
              <b>Drag or browse file to upload or &nbsp;</b>
              <button
                type="button"
                style={{
                  color: "#006cbe",
                  cursor: "pointer",
                  background: "none",
                  border: "none",
                  padding: 0,
                  font: "inherit",
                  fontWeight: "bold",
                }}
                aria-label={termsAndCondiditionSelectedFile?.name 
                  ? `Selected file: ${termsAndCondiditionSelectedFile.name}` 
                  : 'Browse your file'}
                onClick={handleTermsAndConditionClick}
              >
                {termsAndCondiditionSelectedFile?.name
                  ? `${termsAndCondiditionSelectedFile?.name}`
                  : `browse your file`}
              </button>
            </Stack>
            <input
              type="file"
              accept=".pdf"
              aria-label="Upload terms and conditions PDF"
              ref={termsAndConditionFileInputRef}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleTermsAndConditionFileChange(e);
              }}
              style={{ display: "none" }}
            />
          </Stack>
        </Card>
      </Stack>
      <Stack style={{ marginLeft: "330px" }} horizontal>
        <PrimaryButton
          text="Submit"
          type="button"
          style={SubmitButtonStyle}
          onClick={(e: any) => _OnClickSubmitButton(e)}
        />
      </Stack>
    </Stack>
  );
};
export default CountryProfileDetails;
